/**
 * Token Manager Utility
 *
 * Phiên thường: localStorage. Tab "đăng nhập thay" (super admin dùng tài khoản nhân
 * viên): sessionStorage riêng của tab — luật nằm ở helpers/tokenStore.cjs (có test).
 */
import tokenStore from '@/helpers/tokenStore.cjs';

// Chỉ đọc property `sessionStorage` cũng có thể ném (trình duyệt chặn site data).
const session = (() => {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
})();

export const tokenManager = tokenStore.createTokenStore(window.localStorage, session);
export const tokenFromHash = tokenStore.tokenFromHash;
